import { useCallback } from 'react';

import type { createPageEditorPluginAIOptions } from '@atlassian/editor-plugin-ai/ConfluencePrebuilt';

type EditorPluginAIOptions = Parameters<typeof createPageEditorPluginAIOptions>[0];

type UseGetChannelVariables = (
	cloudId: string,
	userId: string,
	orgId?: string,
) => EditorPluginAIOptions['getChannelVariables'];

export const useGetChannelVariables: UseGetChannelVariables = (cloudId, userId, orgId) => {
	return useCallback(
		(purpose: string) => {
			if (purpose === 'rovo-agent') {
				return {
					contentURL: window.location.origin + window.location.pathname,
					cloudId,
					userId,
					orgId,
				};
			}
			return null;
		},
		[cloudId, userId, orgId],
	);
};
